import { WidgetKey, WidgetSize } from 'shared/constants/widgets'
import { AiArtifactConfig } from 'shared/types/widgets'

export const buildWidgetDragPayload = (
  widgetKey: WidgetKey,
  size: WidgetSize,
  config?: AiArtifactConfig
) => ({
  type: 'widget' as const,
  widget: { widgetKey },
  sidePanelSize: size,
  source: 'marketplace' as const,
  ...(config ? { config } : {})
})
